//Dipendenze
//Axios, @material-ui/core, @material-ui/icons, react-router-dom, uuid, @auth0/auth0-react, nanoid
//
//npm install --save --legacy-peer-deps @material-ui/icons se ti da errore con 16.8 e 17.01

import { Route, Switch } from "react-router-dom";

import HomePage from "./components/HomePage";
import ViewResearch from "./components/ViewResearch";
import Admin from "./components/admin/Admin";
import NewRecord from "./components/admin/NewRecord";

//Predispongo due ROUTE:
// 1- alla radice '/' che sarebbe l'elenco completo delle Ricerche
// 2- ad Admin per la gestione dei singoli record
// 3- alla singola ricerca individuata dal numero di 'id' -> ricercaId

function App() {
  return (
    <Switch>
      <Route exact path="/" render={(props) => <HomePage {...props} />} />
      <Route path="/admin" component={ Admin } />
      {/* <Route path="/NewRecord" component={ NewRecord } /> */}
      <Route
        path="/:ricercaId"
        render={(props) => <ViewResearch {...props} />}
      />
    </Switch>
  );
}

export default App;
